import React, { useState, useEffect, useRef } from "react";
import { useLocation, Link } from 'react-router-dom';
import { toLowerCasePath } from '../extensions/utilityExtensions';

import "./styles/burgerMenu.css";

function BurgerMenu() {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();
    const menuRef = useRef(null);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    // Close menu when route changes
    useEffect(() => {
        setIsOpen(false);
    }, [location]);

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const isActive = (path) => {
        return location.pathname === toLowerCasePath(path);
    };

    return (
        <div className="burger-menu-container" ref={menuRef}>
            {/* Hamburger Button */}
            <button
                className={`burger-toggle ${isOpen ? 'open' : ''}`}
                onClick={toggleMenu}
                aria-label="Toggle menu"
            >
                <span></span>
                <span></span>
                <span></span>
            </button>

            {/* Dropdown Menu */}
            <div className={`burger-dropdown ${isOpen ? 'open' : ''}`}>
                <nav className="burger-nav">
                    <Link
                        to="/"
                        className={`burger-link ${isActive('/') ? 'active' : ''}`}
                        onClick={() => setIsOpen(false)}
                    >
                        Home
                    </Link>
                    <Link
                        to={toLowerCasePath("/library")}
                        className={`burger-link ${isActive('/library') ? 'active' : ''}`}
                        onClick={() => setIsOpen(false)}
                    >
                        Library
                    </Link>
                    <Link
                        to={toLowerCasePath("/about")}
                        className={`burger-link ${isActive('/about') ? 'active' : ''}`}
                        onClick={() => setIsOpen(false)}
                    >
                        About
                    </Link>
                    <Link
                        to={toLowerCasePath("/contact-us")}
                        className={`burger-link ${isActive('/contact-us') ? 'active' : ''}`}
                        onClick={() => setIsOpen(false)}
                    >
                        Contact
                    </Link>
                </nav>
            </div>
        </div>
    );
}

export default BurgerMenu;